module.exports = __webpack_public_path__ + "static/media/madBGDesktop.e96f6c20.webp";